export class VehiclesAssociatesAddressesQueryParameters {
  apxCode?: string;
  associateId?: string;
  businessManagerId?: string;
  categoryId?: string;
  codeId?: string;
  colourId?: string;
  convertibleFlag?: string;
  driverId?: string;
  driveTrain?: string;
  engine?: string;
  employeeId?: string;
  extendedWarrantyId?: string;
  extendedWarrantyPlanId?: string;
  exteriorColourCode?: string;
  genericModelId?: string;
  groupId?: string;
  id?: string;
  interiorColourCode?: string;
  keyCodeDoor?: string;
  keyCodeIgnition?: string;
  leaseVehicleOperatorId?: string;
  make?: string;
  manufacturerId?: string;
  optimumUsedFlag?: string;
  orderDateFrom?: Date;
  orderDateTo?: Date;
  orderNumber?: string;
  page?: number;
  pageSize?: number;
  passengerFlag?: string;
  prospectTypeId?: string;
  regularWarrantyId?: string;
  rooftopId?: string;
  saleId?: string;
  salespersonId?: number;
  search?: string;
  soldDateFrom?: Date;
  soldDateTo?: Date;
  statusCode?: string;
  stockNumber?: string;
  subCategoryId?: string;
  subTypeId?: string;
  typeId?: string;

  year?: string;

  constructor(obj?: VehiclesAssociatesAddressesQueryParameters) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
